import './header.css'
import React from 'react'
// components
import CTA from './CTA'
import ME from '../../assets/me.png'
import HeaderSocials from './HeaderSocials'
import {BsArrowRight} from 'react-icons/bs'

const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Abhishek Yadav</h1>
        <h5 className="text-light">Mern Stack Developer</h5>
        <CTA />

        <HeaderSocials />

        <div className="me">
          <img src={ME} alt="me" />
        </div>

        <a href="#about" className='scroll_down'>Scroll Down <span><BsArrowRight /></span></a>
      </div>
    </header>
  )
}

export default Header